import * as types from './types';
export default {
  [types.SET_CURRENT_ROUTE](state, payload) {
    var currentState = state;
    currentState.currentRoute = payload;
  },
  [types.SET_PREVIOUS_ROUTE](state, payload) {
    var currentState = state;
    currentState.previousRoute = payload;
  }
};